"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTabletRenderer = exports.AkkadianPhoneticGroups = exports.AkkadianLetterGroupsUpper = exports.AkkadianAlphabetUpper = exports.AkkadianAlphabetLower = exports.photoKeyPrefix = exports.importerInitials = exports.isObject = exports.convertAppliedPropsToItemProps = exports.convertSideToSideNumber = exports.convertSideNumberToSide = exports.formatLineNumber = exports.subscriptNumber = exports.indexOfFirstVowel = exports.normalizeNumber = exports.formatDecimalFraction = exports.normalizeFraction = exports.normalizeSign = exports.tokenizeExplicitSpelling = exports.spellingHtmlReading = exports.TabletRenderer = exports.TabletLineNumRenderer = exports.TabletHtmlRenderer = exports.DiscourseHtmlRenderer = exports.DiscourseRenderer = void 0;
var TabletRenderer_1 = __importDefault(require("./TabletRenderer"));
var TabletHtmlRenderer_1 = __importDefault(require("./TabletHtmlRenderer"));
var TabletLineNumRenderer_1 = __importDefault(require("./TabletLineNumRenderer"));
var DiscourseRenderer_1 = require("./DiscourseRenderer");
Object.defineProperty(exports, "DiscourseRenderer", { enumerable: true, get: function () { return __importDefault(DiscourseRenderer_1).default; } });
var DiscourseHtmlRenderer_1 = require("./DiscourseHtmlRenderer");
Object.defineProperty(exports, "DiscourseHtmlRenderer", { enumerable: true, get: function () { return __importDefault(DiscourseHtmlRenderer_1).default; } });
var TabletHtmlRenderer_2 = require("./TabletHtmlRenderer");
Object.defineProperty(exports, "TabletHtmlRenderer", { enumerable: true, get: function () { return __importDefault(TabletHtmlRenderer_2).default; } });
var TabletLineNumRenderer_2 = require("./TabletLineNumRenderer");
Object.defineProperty(exports, "TabletLineNumRenderer", { enumerable: true, get: function () { return __importDefault(TabletLineNumRenderer_2).default; } });
var TabletRenderer_2 = require("./TabletRenderer");
Object.defineProperty(exports, "TabletRenderer", { enumerable: true, get: function () { return __importDefault(TabletRenderer_2).default; } });
var spellingTokenizer_1 = require("./spellingTokenizer");
Object.defineProperty(exports, "spellingHtmlReading", { enumerable: true, get: function () { return spellingTokenizer_1.spellingHtmlReading; } });
Object.defineProperty(exports, "tokenizeExplicitSpelling", { enumerable: true, get: function () { return spellingTokenizer_1.tokenizeExplicitSpelling; } });
var signNormalizer_1 = require("./signNormalizer");
Object.defineProperty(exports, "normalizeSign", { enumerable: true, get: function () { return signNormalizer_1.normalizeSign; } });
Object.defineProperty(exports, "normalizeFraction", { enumerable: true, get: function () { return signNormalizer_1.normalizeFraction; } });
Object.defineProperty(exports, "formatDecimalFraction", { enumerable: true, get: function () { return signNormalizer_1.formatDecimalFraction; } });
Object.defineProperty(exports, "normalizeNumber", { enumerable: true, get: function () { return signNormalizer_1.normalizeNumber; } });
Object.defineProperty(exports, "indexOfFirstVowel", { enumerable: true, get: function () { return signNormalizer_1.indexOfFirstVowel; } });
Object.defineProperty(exports, "subscriptNumber", { enumerable: true, get: function () { return signNormalizer_1.subscriptNumber; } });
var tabletUtils_1 = require("./tabletUtils");
Object.defineProperty(exports, "formatLineNumber", { enumerable: true, get: function () { return tabletUtils_1.formatLineNumber; } });
Object.defineProperty(exports, "convertSideNumberToSide", { enumerable: true, get: function () { return tabletUtils_1.convertSideNumberToSide; } });
Object.defineProperty(exports, "convertSideToSideNumber", { enumerable: true, get: function () { return tabletUtils_1.convertSideToSideNumber; } });
var parseTreeUtils_1 = require("./parseTreeUtils");
Object.defineProperty(exports, "convertAppliedPropsToItemProps", { enumerable: true, get: function () { return parseTreeUtils_1.convertAppliedPropsToItemProps; } });
var isObject_1 = require("./isObject");
Object.defineProperty(exports, "isObject", { enumerable: true, get: function () { return isObject_1.isObject; } });
var photoKeys_1 = require("./photoKeys");
Object.defineProperty(exports, "importerInitials", { enumerable: true, get: function () { return photoKeys_1.importerInitials; } });
Object.defineProperty(exports, "photoKeyPrefix", { enumerable: true, get: function () { return photoKeys_1.photoKeyPrefix; } });
exports.AkkadianAlphabetLower = 'ăaāâbdeēêgḫhiīîyklmnpqrsṣštṭuūûúwz';
exports.AkkadianAlphabetUpper = 'ĂAĀÂBDEĒÊGḪHIĪÎYKLMNPQRSṢŠTṬUŪÛÚWZ';
exports.AkkadianLetterGroupsUpper = {
    A: 'ĂAĀÂ',
    B: 'B',
    D: 'D',
    E: 'EĒÊ',
    G: 'G',
    Ḫ: 'ḪH',
    I: 'IĪÎ',
    Y: 'Y',
    K: 'K',
    L: 'L',
    M: 'M',
    N: 'N',
    P: 'P',
    Q: 'Q',
    R: 'R',
    S: 'S',
    Ṣ: 'Ṣ',
    Š: 'Š',
    T: 'T',
    Ṭ: 'Ṭ',
    'U/W': 'UŪÛW',
    Z: 'Z',
};
exports.AkkadianPhoneticGroups = {
    a: ['a', 'ā', 'á', 'à', 'â', 'A', 'Ā', 'Á', 'À', 'Â'],
    b: ['b', 'p', 'B', 'P'],
    d: ['d', 't', 'ṭ', 'D', 'T', 'Ṭ'],
    e: ['e', 'é', 'è', 'ē', 'ê', 'E', 'Ē', 'É', 'È', 'Ê'],
    g: ['k', 'q', 'g', 'K', 'G', 'Q'],
    ḫ: ['ḫ', 'h', 'Ḫ', 'H'],
    i: ['i', 'í', 'ì', 'ī', 'î', 'Í', 'Ì', 'Ī', 'Î', 'I'],
    k: ['g', 'k', 'q', 'G', 'K', 'Q'],
    l: ['l', 'L'],
    m: ['M', 'm'],
    n: ['N', 'n'],
    p: ['b', 'p', 'B', 'P'],
    q: ['g', 'k', 'q', 'G', 'K', 'Q'],
    r: ['R', 'r'],
    s: ['s', 'š', 'ṣ', 'z', 'S', 'Ṣ', 'Z', 'Š'],
    ṣ: ['s', 'ṣ', 'z', 'S', 'Ṣ', 'Z'],
    š: ['s', 'š', 'z', 'S', 'Z', 'Š'],
    t: ['d', 't', 'ṭ', 'D', 'T', 'Ṭ'],
    ṭ: ['d', 't', 'ṭ', 'D', 'T', 'Ṭ'],
    u: ['u', 'ù', 'ú', 'ū', 'û'],
    w: ['w', 'W'],
    z: ['s', 'ṣ', 'z', 'S', 'Z', 'Ṣ'],
};
var createTabletRenderer = function (epigraphicUnits, locale, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.textFormat, textFormat = _c === void 0 ? 'regular' : _c, _d = _b.lineNumbers, lineNumbers = _d === void 0 ? false : _d, _e = _b.showNullDiscourse, showNullDiscourse = _e === void 0 ? false : _e, _f = _b.highlightDiscourses, highlightDiscourses = _f === void 0 ? [] : _f;
    var renderer = new TabletRenderer_1.default(epigraphicUnits, locale, textFormat);
    if (textFormat === 'html') {
        renderer = new TabletHtmlRenderer_1.default(renderer, {
            showNullDiscourse: showNullDiscourse,
            highlightDiscourses: highlightDiscourses,
        });
    }
    if (lineNumbers) {
        renderer = new TabletLineNumRenderer_1.default(renderer);
    }
    return renderer;
};
exports.createTabletRenderer = createTabletRenderer;
//# sourceMappingURL=index.js.map